import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import useReveal from './hooks/useReveal';
import { Toaster } from './components/ui/toaster';
import { LanguageProvider } from './i18n/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import LiveMapSection from './components/LiveMapSection';
import Sectors from './components/Sectors';
import Solutions from './components/Solutions';
import Features from './components/Features';
import FieldGallery from './components/FieldGallery';
import Product from './components/Product';
import CaseStudies from './components/CaseStudies';
import Testimonials from './components/Testimonials';
import TechGuide from './components/TechGuide';
import SavingsCounter from './components/SavingsCounter';
import RoiCalculator from './components/RoiCalculator';
import Pricing from './components/Pricing';
import Faq from './components/Faq';
import Contact from './components/Contact';
import Footer from './components/Footer';
import VideoModal from './components/VideoModal';

function Landing() {
  useReveal();
  const [video, setVideo] = useState(false);

  const goToContact = () => {
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="App bg-white">
      <Navbar />
      <main>
        <Hero onDemo={goToContact} onVideo={() => setVideo(true)} />
        <LiveMapSection />
        <Sectors />
        <Solutions />
        <Features />
        <FieldGallery />
        <Product onDemo={goToContact} />
        <TechGuide />
        <CaseStudies />
        <Testimonials />
        <SavingsCounter />
        <RoiCalculator onDemo={goToContact} />
        <Pricing onSelect={goToContact} />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <VideoModal open={video} onClose={() => setVideo(false)} />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
